/** The quick guide's slides, its spoken lines and the ready card. Spoken
 *  lines take the user's shortcut as {shortcut}, already a phrase that
 *  starts with its verb ("Press ⌃ Space", "Double-tap Control"). */
export default {
  pressShortcut: "Press {keys}",
  typeTitle: "Ask right where you’re working.",
  typeDescription: "Open the input bar and tell Denker what you need.",
  voiceTitle: "Talk to Denker.",
  voiceDescription: "Talk, mark your screen, and add your request.",
  workspaceTitle: "Your work has a home.",
  workspaceDescription: "Your tasks, memories and saved results are here.",
  typeOpenLine:
    "{shortcut} to open the input bar and ask right where you’re working.",
  voiceOpenLine: "{shortcut} to start talking to me.",
  workspaceOpenLine: "{shortcut} to open your workspace.",
  typeCloseLine: "{shortcut} again to close the input bar.",
  voiceCloseLine: "{shortcut} again to stop listening.",
  workspaceCloseLine: "{shortcut} again to close your workspace.",
  typeDone: "There’s your input bar.",
  workspaceDone: "This is your workspace.",
  voiceDoneMac: "I’m listening. See the icon up top.",
  voiceDoneWindows: "I’m listening. See the icon in the taskbar.",
  drawInstruction: "{shortcut} to draw and take screenshots.",
  wrapUpLine: "That’s the basics. Click Done when you’re ready.",
  readyLine: "You’re all set.",
  sendHoldHint: "Try it after the guide",
  skipGuide: "Skip guide",
  back: "Back",
  next: "Next",
  done: "Done",
  continue: "Continue",
  stepOf: "Step {step} of {total}",
  livesHereTitle: "By the way, I live here.",
  allSetTitle: "You’re all set.",
  livesInTaskbar: "I live in your taskbar.",
  livesInMenuBar: "I live in your menu bar.",
  workspaceShortcutHint:
    "Open and close your workspace with <shortcut>{label}</shortcut>.",
  bookOnboarding: "Book 1:1 onboarding",
  joinCommunity: "Join the community",
  getStarted: "Get started",
  showMyWorkspace: "Show my workspace",
  linkOpenFailed: "That link couldn’t open. Please try again.",
} as const;
